/** Типы оплаты */
export enum PaymentTypeEnum {
  /** Сплит */
  Split = 0,
  /** Картой */
  Card = 1
}